import React, { useState } from 'react';
import { Users, Layout, CreditCard, GraduationCap } from 'lucide-react';
import { AdminPanel as AdminUsersPanel } from './AdminPanel';
import { AdminLandingEditor } from './AdminLandingEditor';
import { AdminSubscriptions } from './AdminSubscriptions';
import AdminLMSCourses from './AdminLMSCourses';

export function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'users', name: 'Usuarios', icon: Users },
    { id: 'landing', name: 'Landing Page', icon: Layout },
    { id: 'subscriptions', name: 'Suscripciones', icon: CreditCard },
    { id: 'lms', name: 'Cursos LMS', icon: GraduationCap }
  ];

  return (
    <div className="min-h-screen bg-[#02040A] p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Panel de Administración</h1>
          <p className="text-white/60">Gestiona usuarios, contenido y suscripciones</p>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mb-8 border-b border-white/10">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 font-semibold transition-all duration-300 border-b-2 ${
                  activeTab === tab.id
                    ? 'text-[#C5A14C] border-[#C5A14C]'
                    : 'text-white/60 border-transparent hover:text-white/80'
                }`}
              >
                <Icon className="w-5 h-5" />
                {tab.name}
              </button>
            );
          })}
        </div>

        {/* Content */}
        <div className={activeTab === 'lms' ? '' : 'bg-white/5 rounded-2xl p-6 border border-white/10'}>
          {activeTab === 'users' && <AdminUsersPanel />}
          {activeTab === 'landing' && <AdminLandingEditor />}
          {activeTab === 'subscriptions' && <AdminSubscriptions />}
          {activeTab === 'lms' && <AdminLMSCourses />}
        </div>
      </div>
    </div>
  );
}
